import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Fragment } from "react";

import AuthenticatedRoute from './authenticatedRoute';
import ProtectedRoute from './protectedRoute';

import Login from './pages/user/login';
import LoginVerify from './pages/user/verify';
import Profile from './pages/user/profile';
import MyProducts from './pages/products/myProducts';
import AllProducts from './pages/products/allProducts';
import Orders from './pages/orders';
import EditOrder from './pages/orders/edit';
import Couriers from './pages/orders/couriers';
import AddCourier from './pages/orders/addCourier';
import EditCourier from './pages/orders/editCourier';


import ScrollToTop from './partials/ScrollToTop';
import BackDrop from './partials/BackDrop';
import Snackbar from './partials/snackbar';
import Header from './partials/header';
import Footer from './partials/footer';
import ImportModals from './partials/ImportModals';


const Root = () => {

    const { token, mobile } = useSelector(state => state.login);

    return (
        <Router>
            <Fragment>
                <ScrollToTop />
                <BackDrop />
                <Snackbar />
                <Header />
                
                <Routes> 
                    <Route path='/login' element={<AuthenticatedRoute isAuthenticated={!!token}><Login /></AuthenticatedRoute>} />
                    
                    <Route path='/login/verify' element={<AuthenticatedRoute isAuthenticated={!!token}>{mobile.length === 11 ? <LoginVerify /> : <Navigate replace to={ "/login" }/>}</AuthenticatedRoute>} />
                    
                    <Route path='/profile' element={<ProtectedRoute isAuthenticated={!!token}><Profile /></ProtectedRoute>} />
                    <Route path='/my-products' element={<ProtectedRoute isAuthenticated={!!token}><MyProducts /></ProtectedRoute>} />
                    <Route path='/products' element={<ProtectedRoute isAuthenticated={!!token}><AllProducts /></ProtectedRoute>} />
                    <Route path='/orders' element={<ProtectedRoute isAuthenticated={!!token}><Orders /></ProtectedRoute>} />
                    <Route path='/orders/:uniqueCode' element={<ProtectedRoute isAuthenticated={!!token}><EditOrder /></ProtectedRoute>} />
                    <Route path='/couriers' element={<ProtectedRoute isAuthenticated={!!token}><Couriers /></ProtectedRoute>} />
                    <Route path='/couriers/add' element={<ProtectedRoute isAuthenticated={!!token}><AddCourier /></ProtectedRoute>} />
                    <Route path='/couriers/edit/:courierId' element={<ProtectedRoute isAuthenticated={!!token}><EditCourier /></ProtectedRoute>} />

                    <Route path={"*"} element={ <Navigate replace to={ "/login" }/> } />
                    

                    
                </Routes>
                <ImportModals />
                <Footer />
            </Fragment>
        </Router>
    );

}

export default Root;
